import { useState, useCallback, useEffect, useRef } from 'react';
import tableService from '../services/tableService';
import recipeService from '../services/recipeService';
import { TableColumn } from '../types';
import { TableDataResponse } from '../types/api.types';

interface UseTableDataReturn {
  data: any[];
  columns: TableColumn[];
  loading: boolean;
  error: string | null;
  updateData: (newData: any[]) => void;
  refreshData: (tableId?: string) => Promise<void>;
  validateData: () => { isValid: boolean; errors: string[] };
}

export const useTableData = (
  initialTableId?: string,
  refreshTrigger?: number // 新增：刷新触发器
): UseTableDataReturn => {
  const [data, setData] = useState<any[]>([]);
  const [columns, setColumns] = useState<TableColumn[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const currentTableIdRef = useRef<string | undefined>(initialTableId); // 保存当前tableId

  const updateData = useCallback((newData: any[]) => {
    setData(newData);
    setError(null);
  }, []);

  const refreshData = useCallback(async (tableId?: string) => {
    // 更新当前tableId引用
    if (tableId !== undefined) {
      currentTableIdRef.current = tableId;
    }
    
    // const recipe = await recipeService.getTableCollectionName(tableId || currentTableIdRef.current || '');
    // console.log("刷新表格数据开始:", recipe);
    const targetTableId = tableId !== undefined ? tableId : currentTableIdRef.current;
    // const targetTableId = tableId;
    if (!targetTableId) {
      // 没有tableId时显示空表格
      setColumns(tableService.generateDefaultColumns());
      // setData(tableService.generateEmptyData());
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response: TableDataResponse = await tableService.fetchTableData(targetTableId);
      console.log("有重新进来请求吗", targetTableId, response, currentTableIdRef.current);
      
      setColumns(response.columns);
      setData(response.records);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '获取表格数据失败';
      setError(errorMessage);
      console.error('刷新表格数据失败:', err);
      
      // 失败时使用默认配置
      setColumns(tableService.generateDefaultColumns());
      // setData(tableService.generateEmptyData());
    } finally {
      setLoading(false);
    }
  }, []);

  const validateData = useCallback(() => {
    return tableService.validateTableData(data);
  }, [data]);

  // 初始化数据
  useEffect(() => {
    refreshData(initialTableId);
  }, [refreshData, initialTableId]);

  // 新增：监听刷新触发器
  useEffect(() => {
    if (refreshTrigger && refreshTrigger > 0) {
      console.log('检测到刷新触发器变化:', refreshTrigger);
      refreshData(); // 使用当前保存的tableId进行刷新
    }
  }, [refreshTrigger, refreshData]);

  return {
    data,
    columns,
    loading,
    error,
    updateData,
    refreshData,
    validateData,
  };
};